import React, { Component } from 'react';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { BrowserRouter as Router } from 'react-router-dom';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { deepOrange500, deepOrange700, teal500 } from 'material-ui/styles/colors';

import './App.css';
import Toolbar from './Toolbar';
import MainContent from './MainContent';
import { HttpDefaults } from '../http/Defaults';

import { GetUserMe, GetAuthTokenCookie, SetHttpDefaultHeaders, DelAuthTokenCookie } from '../http/AuthService';

const muiTheme = getMuiTheme({
    palette: {
        primary1Color: deepOrange500,
        primary2Color: deepOrange700,
        accent1Color: teal500,
    },
}, {});

class App extends Component {
    constructor(props) {
        super(props);

        const { cookies } = props;

        const token = GetAuthTokenCookie(cookies);

        if (token) {
            SetHttpDefaultHeaders(token);
        }

        this.state = {
            logoff: false,
            auth: Boolean(token) || null
        };

        this.updateUser = this.updateUser.bind(this);
        this.handleLogoff = this.handleLogoff.bind(this);
    }

    componentDidMount() {
        const { cookies } = this.props;

        if (GetAuthTokenCookie(cookies)) {
            GetUserMe()
                .then(result => this.updateUser(result.data))
                .catch(err => this.updateUser(null));
        }
    }

    updateUser(user) {
        this.setState({ auth: user });
    }

    handleLogoff() {
        const { cookies } = this.props;
        DelAuthTokenCookie(cookies);
        this.setState({ auth: null, logoff: true });
    }

    render() {
        const { auth } = this.state;
        const { logoff } = this.state;
        const { cookies } = this.props;

        HttpDefaults();

        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <Router>
                    <div>
                        <Toolbar auth={auth} logoff={this.handleLogoff} />
                        <MainContent auth={auth} cookies={cookies} updateUser={this.updateUser} logoff={logoff}/>
                    </div>
                </Router>
            </MuiThemeProvider>
        );
    }
}

App.propTypes = {
    cookies: instanceOf(Cookies).isRequired
};

export default withCookies(App);



// WEBPACK FOOTER //
// ./src/components/layout/App.js